import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
	'CREATE_TELTONIKA_INDICATOR',
	'UPDATE_TELTONIKA_INDICATOR',
	'DELETE_TELTONIKA_INDICATOR',
	'GET_TELTONIKA_INDICATOR'
);
